
import {defineComponent} from 'vue';

export default defineComponent({
  props: {
    company: {
      type: Object, // both Bedrijf and Organisatie
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
});
